"use client";

import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { CartIcon } from "@/components/shop/CartIcon";
import { ProductsSearch } from "@/components/shop/ProductsSearch";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function HeaderPrincipale() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header-principale" className={`sticky top-0 z-50 w-full transition-all duration-300 text-foreground ${isScrolled ? "bg-background/70 backdrop-blur-lg border-b border-border" : "bg-background border-b border-transparent"}`}>
      <div className="container mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        {}
        <div className="flex-shrink-0">
          <Link to="/" className="block outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
            <WvcLogo className="h-7 w-auto" />
          </Link>
        </div>

        {}
        <div className="flex items-center gap-4 md:gap-6">
          {}
          <Popover>
            <PopoverTrigger asChild>
              <Button variant="ghost" size="icon" className="text-foreground hover:text-primary transition-colors" aria-label="Cerca prodotti">
                <Search className="size-5" />
              </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-72 p-3 shadow-lg rounded-lg border-border bg-popover">
              <ProductsSearch value={searchQuery} onChange={setSearchQuery} placeholder="Cerca prodotti..." className="w-full" />
            </PopoverContent>
          </Popover>

          {}
          <CartIcon variant="ghost" size="icon" className="text-foreground hover:text-primary transition-colors" iconSize="size-5" />

          {}
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-6 font-medium shadow-md transition-all">
            <Link to="#">Inizia Ora</Link>
          </Button>
        </div>
      </div>
    </section>;
}